import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { getLocaleFirstDayOfWeek } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DateTranslatedAdapter extends NativeDateAdapter {
  constructor(private readonly translateService: TranslateService) {
    super();
    this.translateService.onLangChange.subscribe(({ lang }) => {
      this.setLocale(lang);
    });
  }

  override getFirstDayOfWeek(): number {
    return getLocaleFirstDayOfWeek(this.translateService.currentLang);
  }
}
